import { render } from "./ValetProposal.vue?vue&type=template&id=0d0840cb&scoped=true"
import script from "./ValetProposal.vue?vue&type=script&lang=js"
export * from "./ValetProposal.vue?vue&type=script&lang=js"

import "./ValetProposal.vue?vue&type=style&index=0&id=0d0840cb&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0840cb"]])

export default __exports__